export const SUBMIT_MORE_DETAILS_FORM =
  'src/MoreDetails/SUBMIT_MORE_DETAILS_FORM'
